"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getEnsuredProjectIdFromProcessor_1 = __importDefault(require("../getEnsuredProjectIdFromProcessor"));
const GeoFire_1 = __importDefault(require("../utils/GeoFire"));
const callableGeoFireRemoveBuilder = async ({ functionId, callbacks, executeProcesses, processor, entryVars: { keyLocation, groupName, }, }) => {
    try {
        const projectId = (0, getEnsuredProjectIdFromProcessor_1.default)('geoFireRemove', processor);
        const appGeofireDbRef = groupName
            ? processor.root.firebase.database().ref(`projects/${projectId}/geoFireGroups/${groupName}`)
            : processor.root.firebase.database().ref(`projects/${projectId}/geoFire`);
        const geoFire = new GeoFire_1.default(appGeofireDbRef);
        await geoFire.remove(keyLocation);
        executeProcesses(undefined, callbacks.successProcess);
    }
    catch (e) {
        executeProcesses(functionId, callbacks.errorProcess, e);
    }
};
exports.default = callableGeoFireRemoveBuilder;
